// extracted by mini-css-extract-plugin
export default {"emptySquareIcon":"ActionCollection_emptySquareIcon__-GpY1","visible":"ActionCollection_visible__ncvGr"};